import React, { Component } from 'react';

class OldRegs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUserRegs:[]
          }
    }

    componentDidMount(){
        console.log("allregs", this.props.allRegs);
        console.log("userData", this.props.userData);
        let currentUserRegs = this.props.allRegs.filter(r=>r.user_id === this.props.userData.user_id);

        this.setState({currentUserRegs: currentUserRegs});
    }


    render() { 
        return (   
            <div>
                <table className="kwizda-table" style={{width:'100%'}}>
                    <thead>
                        <tr>
                            <th>Név</th>
                            <th>Kultúrák</th>
                            <th>Értékelés</th>
                            <th>Státusz</th>
                            <th>Reg. időpontja</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.currentUserRegs.map((regObj, i)=> (
                        <tr>
                            <td regid={regObj.regid}> {regObj.name}</td>
                            <td> {regObj.usage_cultures} </td>
                            <td> {regObj.evaluation}</td>
                            <td> {regObj.status}</td>
                            <td> {regObj.created}</td>
                        </tr>
                        )
                    )}
                    </tbody>
                </table>
                        
            </div> );
    }
}
 
export default OldRegs;